<template>

  <nav class="navbar is-transparent">

    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img src="/images/cityofpae.png" alt="City of Port Adelaide Enfield">
      </a>

<!--       <a class="navbar-item is-hidden-desktop" href="https://github.com/jgthms/bulma" target="_blank">
        <span class="icon" style="color: #333;">
          <i class="fa fa-github"></i>
        </span>
      </a>

      <a class="navbar-item is-hidden-desktop" href="https://twitter.com/jgthms" target="_blank">
        <span class="icon" style="color: #55acee;">
          <i class="fa fa-twitter"></i>
        </span>
      </a>
 -->
<!--       <div class="navbar-burger burger" data-target="navMenubd-example">
        <span></span>
        <span></span>
        <span></span>
      </div>
 -->

    </div>

    <div id="navMenubd-example" class="navbar-menu">
<!--       <div class="navbar-start">

        <div class="navbar-item has-dropdown is-hoverable is-mega">
          <div class="navbar-link  is-active">
            Live
          </div>
          <div class="navbar-dropdown "  data-style="width: 8rem;">

            <div class="container is-fluid">
              <div class="columns">

                <div class="column">

                  <h1 class="title is-6 is-mega-menu-title">Environment</h1>
                  <a class="navbar-item " href="/">
                    Biodiversity Management
                  </a>
                  <a class="navbar-item " href="/">
                    Climate Change Planning
                  </a>
                  <a class="navbar-item " href="/">
                    Coast and Marine
                  </a>
                  <a class="navbar-item " href="/">
                    Energy and Water Conversation
                  </a>

                </div>

                <div class="column">

                  <h1 class="title is-6 is-mega-menu-title">Roads and Parking</h1>
                  <a class="navbar-item " href="/">
                    Parking and Expiation Notices
                  </a>
                  <a class="navbar-item " href="/">
                    Climate Change Planning
                  </a>
                  <a class="navbar-item " href="/">
                    Coast and Marine
                  </a>
                  <a class="navbar-item " href="/">
                    Energy and Water Conversation
                  </a>

                </div>


              </div>
            </div>

          </div>
        </div>



        <div class="navbar-item has-dropdown is-hoverable is-mega">
          <div class="navbar-link  is-active">
            Explore
          </div>
          <div class="navbar-dropdown "  data-style="width: 8rem;">

            <div class="container is-fluid">
              <div class="columns">

                <div class="column">

                  <h1 class="title is-6 is-mega-menu-title">Environment</h1>
                  <a class="navbar-item " href="/documentation/overview/start/">
                    Biodiversity Management<br/>Biodiversity Management
                  </a>

                </div>

              </div>
            </div>

          </div>
        </div>


        <div class="navbar-item has-dropdown is-hoverable is-mega">
          <div class="navbar-link  is-active">
            Community
          </div>
          <div class="navbar-dropdown "  data-style="width: 8rem;">

            <div class="container is-fluid">
              <div class="columns">

                <div class="column">

                  <h1 class="title is-6 is-mega-menu-title">Environment</h1>
                  <a class="navbar-item " href="/documentation/overview/start/">
                    Biodiversity Management<br/>Biodiversity Management
                  </a>

                </div>

              </div>
            </div>

          </div>
        </div>


        <div class="navbar-item has-dropdown is-hoverable is-mega">
          <div class="navbar-link  is-active">
            Development
          </div>
          <div class="navbar-dropdown "  data-style="width: 8rem;">

            <div class="container is-fluid">
              <div class="columns">

                <div class="column">

                  <h1 class="title is-6 is-mega-menu-title">Environment</h1>
                  <a class="navbar-item " href="/">
                    Biodiversity Management
                  </a>
                  <a class="navbar-item " href="/">
                   Climate Change Planning
                  </a>

                </div>

              </div>
            </div>

          </div>
        </div>



        <div class="navbar-item has-dropdown is-hoverable is-mega">
          <div class="navbar-link  is-active">
            Council
          </div>
          <div class="navbar-dropdown "  data-style="width: 8rem;">

            <div class="container is-fluid">
              <div class="columns">

                <div class="column">

                  <h1 class="title is-6 is-mega-menu-title">Environment</h1>
                  <a class="navbar-item " href="/">
                    Biodiversity Management<br/>Biodiversity Management
                  </a>

                </div>

              </div>
            </div>

          </div>
        </div>



        <div class="navbar-item has-dropdown is-hoverable is-mega">
          <div class="navbar-link  is-active">
            Connect
          </div>
          <div class="navbar-dropdown "  data-style="width: 8rem;">

            <div class="container is-fluid">
              <div class="columns">

                <div class="column">

                  <h1 class="title is-6 is-mega-menu-title">Environment</h1>
                  <a class="navbar-item " href="/">
                    Biodiversity Management<br/>Biodiversity Management
                  </a>

                </div>

              </div>
            </div>

          </div>
        </div>


      </div> -->



<!--       <div class="navbar-end">
        <a class="navbar-item is-hidden-desktop-only" href="https://github.com/jgthms/bulma" target="_blank">
          <span class="icon" style="color: #333;">
            <i class="fa fa-github"></i>
          </span>
        </a>
        <a class="navbar-item is-hidden-desktop-only" href="https://twitter.com/jgthms" target="_blank">
          <span class="icon" style="color: #55acee;">
            <i class="fa fa-twitter"></i>
          </span>
        </a>
        <div class="navbar-item">
          <div class="field is-grouped">
            <p class="control">
              <a class="bd-tw-button button" data-social-network="Twitter" data-social-action="tweet" data-social-target="http://bulma.io" target="_blank" href="https://twitter.com/intent/tweet?text=Bulma: a modern CSS framework based on Flexbox&hashtags=bulmaio&url=http://bulma.io&via=jgthms">
                <span class="icon">
                  <i class="fa fa-twitter"></i>
                </span>
                <span>
                  Tweet
                </span>
              </a>

            </p>
            <p class="control">
              <a class="button is-primary" href="https://github.com/jgthms/bulma/archive/0.5.1.zip">
                <span class="icon">
                  <i class="fa fa-download"></i>
                </span>
                <span>Download</span>
              </a>
            </p>
          </div>
        </div>
      </div> -->


    </div>
  </nav>

</template>

<script>
export default {
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/ui/Navbar.vue